/**
 * Users Administration Page
 * Wraps the existing Admin Users component in SubscriptionLayout
 */

import React from 'react';
import SubscriptionLayout from '../../components/subscription/SubscriptionLayout';
import AdminUsers from '../../admin/Users';

const UsersPage: React.FC = () => {
  return (
    <SubscriptionLayout>
      <AdminUsers />
    </SubscriptionLayout>
  );
};

export default UsersPage;


